import {
  AlertCircle,
  CheckCircle2,
  TriangleAlertIcon,
  XCircle,
} from "lucide-react";

export const MESSAGE_ICON = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  INFO: "INFO",
  WARNING: "WARNING",
} as const;

export type MESSAGE_ICON_TYPE =
  (typeof MESSAGE_ICON)[keyof typeof MESSAGE_ICON];

export const ICON_CONFIG = {
  [MESSAGE_ICON.SUCCESS]: {
    Icon: CheckCircle2,
    // bgColor: "bg-green-100",
    iconColor: "text-green-600",
  },
  [MESSAGE_ICON.ERROR]: {
    Icon: XCircle,
    // bgColor: "bg-red-100",
    iconColor: "text-red-600",
  },
  [MESSAGE_ICON.INFO]: {
    Icon: AlertCircle,
    // bgColor: "bg-blue-100",
    iconColor: "text-blue-600",
  },
  [MESSAGE_ICON.WARNING]: {
    Icon: TriangleAlertIcon,
    // bgColor: "bg-red-100",
    iconColor: "text-orange-600",
  },
} as const;
